import React from "react";

const ViewIcon = ({ fill, small }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={small ? "22" : "32.081"}
      height={small ? "11" : "15.226"}
      viewBox="0 0 32.081 15.226"
    >
      <g id="eye_ic" transform="translate(-2.554 -27.41)">
        <path
          id="Path_1224"
          data-name="Path 1224"
          d="M18.6,27.41c-8.859,0-16.044,7.606-16.044,7.606s7.178,7.616,16.038,7.62S34.635,35.03,34.635,35.03,27.457,27.414,18.6,27.41Zm0,13.113a5.5,5.5,0,1,1,5.5-5.5A5.5,5.5,0,0,1,18.594,40.523Z"
          transform="translate(0 0)"
          fill={fill ? fill : undefined}
        />
        <path
          id="Path_1225"
          data-name="Path 1225"
          d="M46.029,40.728a1.557,1.557,0,0,1-2.372-2.016,3.874,3.874,0,1,0,2.372,2.016Z"
          transform="translate(-23.967 -7.387)"
          fill={fill ? fill : undefined}
        />
      </g>
    </svg>
  );
};

export default ViewIcon;
